import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  Elements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Button } from "@mui/material";
import visaLogo from "../../images/visa.png";
import mastercardLogo from "../../images/mastercard.png";
import "./common.css";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(`process.env.REACT_APP_STRIPE_PK`);

const options = {
  showIcon: true,
  style: {
    base: {
      color: "#424770",
      letterSpacing: "0.025em",
      fontSize: "12px",
      fontFamily:
        '"Montserrat", -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#9e2146",
    },
  },
};

const CheckoutForm = () => {
  return (
    <div className="pb-4 px-10 space-y-4 lg:w-[580px] justify-center">
      <div className="font-bold text-2xl">Payment Details</div>
      <div className="flex flex-wrap items-center justify-between text-base">
        <div className="font-medium">
          <div>Make your payments securley</div>
          <div>through your bank account</div>
        </div>
        <div className="flex items-center space-x-3">
          <img src={visaLogo} className="w-[40px] h-full" alt="visaLogo"></img>
          <img
            src={mastercardLogo}
            className="w-[40px] h-full"
            alt="mastercardLogo"
          ></img>
        </div>
      </div>
      <form>
        <div className="lg:w-[370px] h-full space-y-7 text-base ">
          <div>
            <div>Card Number</div>
            <CardNumberElement options={options} />
          </div>

          <div className="flex w-full space-x-5 ">
            <div className="w-full">
              <div>Expiry</div>
              <CardExpiryElement options={options} />
            </div>
            <div className="w-full">
              <div>CVC</div>
              <CardCvcElement options={options} />
            </div>
          </div>

          <Button
            variant="contained"
            style={{
              fontWeight: "bold",
              borderRadius: "5px",
              fontSize: "14px",
              padding: "5px 38px",
              backgroundColor: "#489CFF",
            }}
          >
            PAY
          </Button>
        </div>
      </form>
    </div>
  );
};
const Payment = () => {
  const options = {
    // passing the client secret obtained from the server
    clientSecret: "{{CLIENT_SECRET}}",
  };

  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm />
    </Elements>
  );
};
export default Payment;
